// extracted by mini-css-extract-plugin
export default {"zoomIn":"styles_zoomIn__12f5d"};